import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import type { Member } from '@/types';

const fetcher = (url: string) => axiosInstance.get(url).then((res) => res.data);

interface CommunityMembersData {
  members: Member[];
  currentUserId?: string;
  metadata: {
    totalCount: number;
    totalPages: number;
    currentPage: number;
    limit: number;
  };
}

export function useFrequentMembers(
  currentUserId?: string,
  communityId?: string,
  options: { page?: number; limit?: number; enabled?: boolean } = {}
) {
  const { page = 1, limit = 5, enabled = true } = options;

  const shouldFetch = Boolean(enabled && communityId && currentUserId);

  const { data, error, isLoading, mutate } = useSWR<CommunityMembersData>(
    shouldFetch
      ? `/api/communities/${communityId}/members/${currentUserId}/frequent?page=${page}&limit=${limit}`
      : null,
    fetcher
  );

  return {
    members: data?.members || [],
    currentUserId: data?.currentUserId,
    metadata: data?.metadata,
    isLoading,
    isError: error,
    mutate,
  };
}
